import React from 'react';

import { InputColumnsProps } from 'types/services/requestService';
import {
  DefaultColumns,
  HousingColumns,
  InsuranceColumns,
  OfficeColumns,
} from './components';

const InputColumns = (props: InputColumnsProps) => {
  const {
    isStartupUser,
    isAngelInvestorUser,
    isTechnicalLicenseUser,
    state,
    details,
    teamMembersOptions,
    setRequestDocuments,
    setIsApplyingForDependant,
    setRelationToTM,
    setIsDependantUAE,
    setDependantGender,
    setDependantFullName,
    setDependantDateOfBirth,
    setChildPlaceOfBirth,
    setIsUserUAERes,
    setPlan,
    setPriceType,
    setQuantity,
    setNoOfDesk,
    setTotalPrice,
    setFurnished,
    setAccommodationType,
    setOfficeType,
    setPassportFile,
    setVisaFile,
    setVisaProofFile,
    setEmiratesIDFile,
    setETAWithSignFile,
    setEmiratesIDNo,
    setPassportNo,
    setTeamMember,
    setAITeamMember,
    setThlTeamMember,
  } = props;

  const { getMemberById, getAngelInvestorMemberById, getTechnicalLicenseMemberById } = props.actions;

  const {
    plan, priceType, quantity,
  } = state.request;

  switch (details.categoryId) {
    case 1: {
      return (
        <OfficeColumns
          setTeamMember={setTeamMember}
          setAITeamMember={setAITeamMember}
          setThlTeamMember={setThlTeamMember}
          setQuantity={setQuantity}
          setNoOfDesk={setNoOfDesk}
          setTotalPrice={setTotalPrice}
          setOfficeType={setOfficeType}
          state={state}
          teamMembersOptions={teamMembersOptions}
          getMemberById={getMemberById}
          getAngelInvestorMemberById={getAngelInvestorMemberById}
          getTechnicalLicenseMemberById={getTechnicalLicenseMemberById}
          member={props.member}
          aIMember={props.aIMember}
          thlMember={props.thlMember}
          isStartupUser={isStartupUser}
          isAngelInvestorUser={isAngelInvestorUser}
          isTechnicalLicenseUser={isTechnicalLicenseUser}
        />
      );
    }
    case 2: {
      return (
        <HousingColumns
          setTeamMember={setTeamMember}
          setAITeamMember={setAITeamMember}
          setThlTeamMember={setThlTeamMember}
          setFurnished={setFurnished}
          setAccommodationType={setAccommodationType}
          state={state}
          teamMembersOptions={teamMembersOptions}
          getMemberById={getMemberById}
          getAngelInvestorMemberById={getAngelInvestorMemberById}
          getTechnicalLicenseMemberById={getTechnicalLicenseMemberById}
          member={props.member}
          aIMember={props.aIMember}
          thlMember={props.thlMember}
          isStartupUser={isStartupUser}
          isAngelInvestorUser={isAngelInvestorUser}
          isTechnicalLicenseUser={isTechnicalLicenseUser}
          setQuantity={setQuantity}
        />
      );
    }
    case 3: {
      return (
        <InsuranceColumns
          isStartupUser={isStartupUser}
          isAngelInvestorUser={isAngelInvestorUser}
          isTechnicalLicenseUser={isTechnicalLicenseUser}
          teamMembersOptions={teamMembersOptions}
          getMemberById={getMemberById}
          getAngelInvestorMemberById={getAngelInvestorMemberById}
          getTechnicalLicenseMemberById={getTechnicalLicenseMemberById}
          state={state}
          plan={plan!}
          member={props.member}
          aIMember={props.aIMember}
          thlMember={props.thlMember}
          setIsApplyingForDependant={setIsApplyingForDependant}
          setRelationToTM={setRelationToTM}
          setIsDependantUAE={setIsDependantUAE}
          setDependantGender={setDependantGender}
          setDependantFullName={setDependantFullName}
          setDependantDateOfBirth={setDependantDateOfBirth}
          setChildPlaceOfBirth={setChildPlaceOfBirth}
          setIsUserUAERes={setIsUserUAERes}
          setPassportFile={setPassportFile}
          setVisaFile={setVisaFile}
          setTeamMember={setTeamMember}
          setAITeamMember={setAITeamMember}
          setThlTeamMember={setThlTeamMember}
          setPlan={setPlan}
          setVisaProofFile={setVisaProofFile}
          setEmiratesIDFile={setEmiratesIDFile}
          setRequestDocuments={setRequestDocuments}
          setETAWithSignFile={setETAWithSignFile}
          setQuantity={setQuantity}
          setEmiratesIDNo={setEmiratesIDNo}
          setPassportNo={setPassportNo}
        />
      );
    }
    default: {
      return (
        <DefaultColumns
          details={details}
          setPriceType={setPriceType}
          setQuantity={setQuantity}
          quantity={quantity}
          priceType={priceType!}
        />
      );
    }
  }
}

export default InputColumns;
